var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"evoucher-instro container"},[_c('div',{staticClass:"evoucher-instro-title mb-2"},[_vm._v("สิ่งที่คุณจะได้รับ")]),_c('div',{staticClass:"evoucher-instro-description"},[_vm._v(" "+_vm._s(_vm.serviceDesc)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }